"use client";

import { cn } from "../../cn";
import { LOGO_TAMI_ICON } from "../../brands/logo-tami";

export function IALogoIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 2457 2630"
      fill="none"
      className={cn("w-6 h-auto text-white", className)}
      {...props}
    >
      <path
        d="M274.058 643.698L917.111 182.484C1024.92 105.161 1183.12 92.1734 1302.21 142.673C1459.88 209.524 1826.46 366.987 2031.44 462.024C2236.42 557.061 2293.66 768.4 2296.65 862.189L2370.16 1573.21C2394.42 1782.01 2302.39 1912.97 2208.38 1981.12C2065.82 2084.45 1738.39 2321.58 1569.1 2443.4C1399.81 2565.21 1162.49 2506.17 1064.99 2461.43C935.751 2404.44 628.369 2268.1 432.741 2178.68C237.113 2089.27 172.067 1893.16 163.998 1806.28L89.9826 1090.31C64.638 845.144 202.139 690.416 274.058 643.698Z"
        fill="currentColor"
      />
      <path
        d="M435.841 757.616L969.941 374.545C1059.48 310.323 1190.88 299.536 1289.8 341.479C1420.75 397.004 1725.22 527.788 1895.47 606.723C2065.72 685.658 2113.26 861.19 2115.75 939.088L2176.8 1529.64C2196.95 1703.06 2120.51 1811.84 2042.43 1868.44C1924.03 1954.26 1652.07 2151.22 1511.46 2252.39C1370.86 2353.57 1173.74 2304.53 1092.76 2267.37C985.423 2220.03 730.122 2106.79 567.639 2032.53C405.156 1958.26 351.131 1795.38 344.428 1723.22L282.954 1128.56C261.903 924.931 376.108 796.419 435.841 757.616Z"
        fill="#0A0A0A"
      />
      <path
        d="M1341.73 1260.43L1816.67 917.826C1863.2 881.469 1964.22 896.266 1977.02 986.55L2038.22 1578.55C2047.47 1668 2011.39 1721.11 1935.05 1777.77L1512.34 2085.66C1402.47 2164.1 1353.13 2102.12 1346.31 2031.98C1330.85 1873.1 1296.63 1529.07 1283.46 1424.03C1270.29 1318.98 1316.82 1271.2 1341.73 1260.43Z"
        fill="currentColor"
      />
      <ellipse
        cx="1879.09"
        cy="1586.42"
        rx="65.0908"
        ry="98.9984"
        transform="rotate(174.098 1879.09 1586.42)"
        fill="#0A0A0A"
      />
      <ellipse
        cx="1605.5"
        cy="1752.09"
        rx="72.1823"
        ry="98.9984"
        transform="rotate(174.098 1605.5 1752.09)"
        fill="#0A0A0A"
      />
    </svg>
  );
}

export function LogoIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      viewBox={LOGO_TAMI_ICON.viewBox}
      fill="none"
      className={cn("size-6 text-foreground", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={LOGO_TAMI_ICON.d}
        fill="currentColor"
      />
    </svg>
  );
}

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

export const TamiBrandLog: React.FC<SvgIconProps> = ({
  className = "",
  size = "md",
  ...props
}) => {
  const sizeClasses = {
    sm: "w-16 h-4",
    md: "w-20 h-5",
    lg: "w-24 h-6",
    xl: "w-32 h-8",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${sizeClasses[size]} ${className}`}
      fill="none"
      viewBox="0 0 100 23"
      {...props}
    >
      <g fill="currentColor" clipPath="url(#clip0_242_103)">
        <path d="M0 2.73C0 1.224 1.277 0 2.852 0h17.807c1.574 0 2.851 1.223 2.851 2.73v.606a.78.78 0 0 1-.417.684l-10.38 5.607a.85.85 0 0 1-.402.102H.82C.366 9.729 0 9.377 0 8.943zM2.852 22.51C1.277 22.51 0 21.289 0 19.78v-7.296c0-.434.367-.786.82-.786h9.575c.453 0 .82.352.82.786v9.241c0 .434-.367.786-.82.786zM23.51 19.78c0 1.508-1.277 2.73-2.852 2.73h-6.58c-.452 0-.82-.351-.82-.785v-9.57a.78.78 0 0 1 .416-.683l8.611-4.68c.547-.296 1.225.082 1.225.684zM34.53 2.637c0-.21.175-.38.39-.38h2.888c.215 0 .39.17.39.38v3.52c0 .211.174.382.389.382h3.629c.215 0 .39.17.39.38v2.533c0 .21-.175.38-.39.38h-3.63c-.214 0-.388.171-.388.382v5.251q0 1.91.773 2.701.808.791 2.658.79h.684c.162 0 .292.128.292.286v2.822c0 .158-.13.285-.292.285h-.684q-3.668 0-5.384-1.646-1.715-1.68-1.715-5.238v-5.251c0-.21-.175-.381-.39-.381h-1.643a.385.385 0 0 1-.39-.381V6.919c0-.21.175-.38.39-.38h1.643c.215 0 .39-.17.39-.381zM44.243 14.443q0-1.779.64-3.294a7.9 7.9 0 0 1 1.75-2.602 7.8 7.8 0 0 1 2.691-1.713q1.548-.625 3.399-.625 3.768 0 6.123 2.207 2.389 2.206 2.96 6.324l1.03 7.285a.287.287 0 0 1-.288.324h-3.11a.29.29 0 0 1-.29-.247l-.318-2.335c-.037-.275-.428-.35-.588-.122a7.25 7.25 0 0 1-2.19 2.045q-1.648.99-3.801.989a8.1 8.1 0 0 1-3.196-.626 7.9 7.9 0 0 1-2.558-1.713q-1.044-1.086-1.648-2.602-.606-1.514-.606-3.294m3.701 0q0 1.088.337 1.977.37.89 1.01 1.548.638.625 1.513.988.908.33 1.986.33t1.951-.33a4.6 4.6 0 0 0 1.547-.988 4.2 4.2 0 0 0 1.01-1.548q.37-.89.37-1.977a5.1 5.1 0 0 0-.37-1.976 4.1 4.1 0 0 0-.977-1.548 4.05 4.05 0 0 0-1.547-.989 5.3 5.3 0 0 0-1.985-.362q-1.078 0-1.986.362-.874.33-1.514.989a4.4 4.4 0 0 0-1.01 1.548q-.336.89-.336 1.976zm6.998-11.987q1.073 0 1.308-1.23a.31.31 0 0 1 .3-.253h1.556a.28.28 0 0 1 .286.295q-.126 1.666-.992 2.637-.942 1.053-2.524 1.054a3.8 3.8 0 0 1-1.346-.23q-.572-.266-1.076-.56-.505-.33-.942-.56a1.73 1.73 0 0 0-.908-.264 1.19 1.19 0 0 0-.942.428q-.268.315-.366.799a.314.314 0 0 1-.303.256h-1.586a.28.28 0 0 1-.286-.295q.126-1.667.992-2.636.975-1.054 2.558-1.054.74 0 1.312.264.606.23 1.076.56.505.296.942.56.471.229.942.23zM85.09 6.208q5.417 0 6.359 6.753l1.299 9.063a.287.287 0 0 1-.29.326h-3.145a.29.29 0 0 1-.288-.246l-1.21-8.286Q87.21 9.47 83.98 9.47q-1.616 0-2.558 1.087t-.942 2.9v8.608c0 .158-.13.286-.292.286H77.07a.29.29 0 0 1-.292-.286v-8.74q0-1.78-.91-2.8-.907-1.054-2.523-1.054c-1.076 0-1.973.363-2.624 1.087q-.976 1.055-.976 2.9v8.608c0 .158-.13.286-.292.286H66.37a.29.29 0 0 1-.292-.286V6.823c0-.158.13-.285.292-.285h3.083c.161 0 .292.127.292.285v1.064c0 .307.5.434.697.193a4.7 4.7 0 0 1 1.254-1.082q1.279-.79 3.061-.79 1.885 0 3.196.857a4.74 4.74 0 0 1 1.658 1.782c.123.224.479.23.607.01a5.1 5.1 0 0 1 1.705-1.79q1.345-.858 3.163-.858zM95.982 6.825c0-.158.13-.286.292-.286h3.083c.162 0 .292.128.292.286v15.24c0 .158-.13.285-.292.285h-3.083a.29.29 0 0 1-.292-.285zM99.134 2.427h-2.547c-.324 0-.588.192-.588.428v1.57c0 .237.264.43.588.43h2.547c.325 0 .588-.193.588-.43v-1.57c0-.236-.263-.428-.588-.428"></path>
      </g>
      <defs>
        <clipPath id="clip0_242_103">
          <path fill="#fff" d="M0 0h100v23H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
